import { Button } from "@blueprintjs/core";
import MyLocationTwoTone from "@material-ui/icons/MyLocationTwoTone";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import Topic from "~/components/CustomerSupport/Topic";
import { IOrder } from "~/graphql/queries/order/orderByNumberAndPostalCode";
import { shipmentIdsFromOrder } from "~/helpers/shipmentIdsFromOrder";
import { StyledCard as Card } from "~/layouts/StyledCard";

interface IProps {
  order: IOrder;
}

class BanggoodShipmentDetail extends React.Component<IProps & WithTranslation> {
  public render() {
    return this.getTrackingIds().length
      ? this.render17TrackButton()
      : this.renderFallback();
  }

  private render17TrackButton() {
    const { t, order } = this.props;

    return (
      <>
        <Card>
          <Topic
            icon={MyLocationTwoTone}
            title={t("title")}
            description={t("description", { order })}
          />
        </Card>

        <Button large={true} intent="primary" onClick={this.handle17TrackClick}>
          {t("trackNowBtn")}
        </Button>
      </>
    );
  }

  private renderFallback() {
    const { t, order } = this.props;

    if (order.shipmentPrice === 0) {
      return (
        <Card>
          <Topic
            icon={MyLocationTwoTone}
            title={t("title")}
            description={t("description.noTrackAndTrace")}
          />
        </Card>
      );
    }

    return (
      <Card>
        <Topic
          icon={MyLocationTwoTone}
          title={t("title")}
          description={t("description.trackAndTracePending")}
        />
      </Card>
    );
  }

  private getTrackingIds() {
    return shipmentIdsFromOrder(this.props.order);
  }

  private handle17TrackClick = () => {
    const trackingIds = this.getTrackingIds().join(",");
    window.open(`https://t.17track.net/en#nums=${trackingIds}`);
  };
}

export default withTranslation("trackTrace")(BanggoodShipmentDetail);



// WEBPACK FOOTER //
// ./src/components/TrackTrace/BanggoodShipmentDetail.tsx